import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AuthGate } from "./auth";
import { AppLayout } from "./layout";

const DashboardPage = lazy(() => import("./pages/dashboard").then((module) => ({ default: module.DashboardPage })));
const InsiderDetailPage = lazy(() => import("./pages/insider-detail").then((module) => ({ default: module.InsiderDetailPage })));
const InsidersPage = lazy(() => import("./pages/insiders").then((module) => ({ default: module.InsidersPage })));
const InvestorDetailPage = lazy(() => import("./pages/investor-detail").then((module) => ({ default: module.InvestorDetailPage })));
const NewInsiderPage = lazy(() => import("./pages/new-insider").then((module) => ({ default: module.NewInsiderPage })));
const NewInvestorPage = lazy(() => import("./pages/new-investor").then((module) => ({ default: module.NewInvestorPage })));
const NotificationSettingsPage = lazy(() => import("./pages/notification-settings").then((module) => ({ default: module.NotificationSettingsPage })));
const PoliticiansPage = lazy(() => import("./pages/politicians").then((module) => ({ default: module.PoliticiansPage })));
const NewPoliticianPage = lazy(() => import("./pages/new-politician").then((module) => ({ default: module.NewPoliticianPage })));
const page = (element: React.ReactNode) => <Suspense fallback={<div className="page-wrap"><div className="notice neutral">Loading…</div></div>}>{element}</Suspense>;

const router = createBrowserRouter([{ element: <AuthGate><AppLayout /></AuthGate>, children: [
  { path: "/", element: page(<DashboardPage />) },
  { path: "/investors/new", element: page(<NewInvestorPage />) },
  { path: "/investors/:id", element: page(<InvestorDetailPage />) },
  { path: "/insiders", element: page(<InsidersPage />) },
  { path: "/insiders/new", element: page(<NewInsiderPage />) },
  { path: "/insiders/:id", element: page(<InsiderDetailPage />) },
  { path: "/politicians", element: page(<PoliticiansPage />) },
  { path: "/politicians/new", element: page(<NewPoliticianPage />) },
  { path: "/settings/notifications", element: page(<NotificationSettingsPage />) },
  { path: "*", element: <div className="narrow-wrap"><section className="panel unavailable-state"><h2>Page not found</h2></section></div> },
]}]);

export function App() { return <RouterProvider router={router} />; }
